import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Cabserviceinkalyan() {



  const cardData = {
    keyword: " Cab Service in Kalyan  ",


"headingDescription": "Royal Route Cab offers reliable and comfortable cab services in Kalyan, providing safe, affordable, and 24/7 travel solutions for local rides, airport transfers, corporate travel, and outstation journeys. Whether you are commuting within Kalyan, traveling to Mumbai, or planning long-distance trips, our professional drivers and well-maintained vehicles ensure a smooth and stress-free experience. We focus on punctual pickups, transparent pricing, clean cars, and hassle-free booking with no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and dedicated customer support, Royal Route Cab is your trusted choice for cab service in Kalyan.",
"topPlaces": [
  {
    "title": "Kalyan to Lonavala",
    "description": "Lonavala is one of the most popular weekend destinations from Kalyan, known for its lush green hills, waterfalls, and scenic viewpoints. Attractions like Bhushi Dam, Tiger’s Leap, and Rajmachi Point make it a perfect short getaway for families and friends."
  },
  {
    "title": "Kalyan to Pune",
    "description": "Pune is a major cultural and educational hub near Kalyan, offering attractions like Shaniwar Wada, Aga Khan Palace, and Sinhagad Fort. It is ideal for business trips, family travel, and weekend visits."
  },
  {
    "title": "Kalyan to Nashik",
    "description": "Nashik is a famous pilgrimage and wine tourism destination known for Trimbakeshwar Temple, Sula Vineyards, Panchavati, and Godavari Ghats. It is one of the most frequently traveled outstation routes from Kalyan."
  },
  {
    "title": "Kalyan to Shirdi",
    "description": "Shirdi is a highly revered pilgrimage destination dedicated to Sai Baba. Travelers from Kalyan often book outstation cabs for a comfortable and peaceful darshan experience with flexible travel options."
  },
  {
    "title": "Kalyan to Mahabaleshwar",
    "description": "Mahabaleshwar is a scenic hill station known for strawberry farms, cool weather, waterfalls, and viewpoints like Arthur’s Seat and Venna Lake. It is a perfect family and couple getaway destination."
  },
  {
    "title": "Kalyan to Matheran",
    "description": "Matheran is an eco-friendly hill station where vehicles are restricted, offering a peaceful environment, toy train rides, forest trails, and beautiful viewpoints. It is one of the closest hill stations from Kalyan."
  },
  {
    "title": "Kalyan to Alibaug",
    "description": "Alibaug is a popular coastal destination known for clean beaches, sea forts, and a relaxing atmosphere. It is ideal for short weekend trips and family beach vacations."
  },
  {
    "title": "Kalyan to Igatpuri",
    "description": "Igatpuri is a serene hill station surrounded by the Sahyadri ranges, famous for waterfalls, greenery, and peaceful weather. It is especially attractive during monsoon season."
  },
  {
    "title": "Kalyan to Aurangabad",
    "description": "Aurangabad is famous for UNESCO World Heritage Sites like Ajanta and Ellora Caves, along with historical monuments such as Bibi Ka Maqbara and Daulatabad Fort. It is ideal for heritage tourism."
  },
  {
    "title": "Kalyan to Goa",
    "description": "Goa is a top long-distance destination from Kalyan, known for beaches, nightlife, water sports, and Portuguese heritage. It is perfect for vacations, group trips, and extended holidays."
  }
],






services: [
  {
    name: "Cab Service in Kalyan",
    description: "Cab service in Kalyan offers reliable and convenient transportation for local travel, airport transfers, and outstation trips. With well-maintained vehicles and professional drivers, this service ensures comfort and safety. Ideal for families, office commuters, and travelers. It guarantees a smooth and hassle-free journey."
  },
  {
    name: "Cab Service in Dombivali",
    description: "Cab service in Dombivali provides easy and accessible travel solutions across the city and nearby areas. This service is perfect for daily commuting and short trips. Vehicles are clean and driven by experienced chauffeurs. It ensures a comfortable travel experience."
  },
  {
    name: "Taxi Service in Kalyan",
    description: "Taxi service in Kalyan ensures quick and convenient transportation for daily travel needs. This service includes local rides, airport transfers, and outstation travel. Professional drivers ensure safe and timely service. It guarantees a smooth journey."
  },
  {
    name: "Taxi Service in Dombivali",
    description: "Taxi service in Dombivali offers dependable travel solutions for city rides and long-distance journeys. Clean vehicles and trained drivers ensure comfort and safety. Flexible booking options enhance convenience. It ensures a reliable experience."
  },
  {
    name: "Kalyan Cab Booking",
    description: "Kalyan cab booking allows customers to reserve rides easily with flexible options. Travelers can choose vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Dombivali Taxi Booking Online",
    description: "Dombivali taxi booking online provides a quick and convenient way to book taxis from anywhere. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Local Cab Service Kalyan",
    description: "Local cab service Kalyan is designed for short-distance travel within the city. This service is ideal for office commutes, shopping trips, and daily errands. Quick availability and flexible booking make it convenient. It ensures smooth city travel."
  },
  {
    name: "Local Cab Service Dombivali",
    description: "Local cab service Dombivali offers reliable transportation for daily city travel. This service is ideal for quick rides and local commutes. Professional drivers ensure safe travel. It guarantees a comfortable experience."
  },
  {
    name: "Outstation Cab Kalyan",
    description: "Outstation cab Kalyan offers comfortable travel to nearby cities and long-distance destinations. This service includes one way and round trip options. Vehicles are maintained for highway travel. It ensures a safe and enjoyable journey."
  },
  {
    name: "Outstation Cab Dombivali",
    description: "Outstation cab Dombivali provides reliable travel for long-distance journeys. This service is ideal for family trips, business travel, and weekend getaways. Comfortable vehicles and experienced drivers ensure smooth travel. It guarantees a hassle-free experience."
  },
  {
    name: "Airport Cab Service Kalyan",
    description: "Airport cab service Kalyan provides seamless pickup and drop to Mumbai airport. This service ensures timely arrival and departure for flights. Professional drivers and clean vehicles enhance comfort. It guarantees a stress-free airport transfer."
  },
  {
    name: "Airport Cab Service Dombivali",
    description: "Airport cab service Dombivali offers reliable transportation to and from Mumbai airport. This service is ideal for business travelers and tourists. Comfortable vehicles and punctual drivers ensure convenience. It ensures smooth airport travel."
  },
  {
    name: "Cheap Cab Service Kalyan",
    description: "Cheap cab service Kalyan offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures affordable travel."
  },
  {
    name: "Cheap Cab Service Dombivali",
    description: "Cheap cab service Dombivali provides economical transportation solutions for daily travel needs. Affordable fares and reliable vehicles make it suitable for regular use. It ensures cost-effective and comfortable journeys."
  },
  {
    name: "Best Taxi Service Kalyan",
    description: "Best taxi service Kalyan ensures premium travel experience with well-maintained vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. It guarantees a reliable journey."
  },
  {
    name: "Best Taxi Service Dombivali",
    description: "Best taxi service Dombivali offers top-quality transportation services for local and outstation travel. Clean vehicles and trained drivers enhance comfort. It ensures a smooth and enjoyable journey."
  },
  {
    name: "24x7 Cab Service Kalyan",
    description: "24x7 cab service Kalyan ensures round-the-clock availability for all travel needs. This service is ideal for late-night rides, early morning airport transfers, and emergency travel. It guarantees convenience anytime."
  },
  {
    name: "24x7 Cab Service Dombivali",
    description: "24x7 cab service Dombivali provides reliable transportation at any time of the day or night. This service is perfect for urgent travel needs and airport transfers. It ensures quick and dependable service."
  }
],

tableData: [
  ["Cab Service in Kalyan", "Cab Service in Dombivali"],
  ["Taxi Service in Kalyan", "Taxi Service in Dombivali"],
  ["Kalyan Cab Booking", "Dombivali Taxi Booking Online"],
  ["Local Cab Service Kalyan", "Local Cab Service Dombivali"],
  ["Outstation Cab Kalyan", "Outstation Cab Dombivali"],
  ["Airport Cab Service Kalyan", "Airport Cab Service Dombivali"],
  ["Cheap Cab Service Kalyan", "Cheap Cab Service Dombivali"],
  ["Best Taxi Service Kalyan", "Best Taxi Service Dombivali"],
  ["24x7 Cab Service Kalyan", "24x7 Cab Service Dombivali"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Cab Service in Kalyan",
    WhyChoosedescription: "Royal Route Cabs offers dependable cab service in Kalyan for local travel, airport transfers, and outstation trips."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are well-trained and experienced in Kalyan, Dombivli, and Mumbai routes, ensuring safe and timely travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "We provide clear and upfront pricing with no hidden costs, ensuring complete transparency in every booking."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Kalyan cab service operates round the clock, allowing you to book a cab anytime for daily or urgent travel needs."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned for a comfortable ride experience."
  },
  {
    WhyChooseheading: "Local & Outstation Travel Options",
    WhyChoosedescription: "We provide cab services for local Kalyan travel, Mumbai airport transfers, and outstation journeys."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for all travel needs."
  },
  {
    WhyChooseheading: "Trusted Cab Service Provider",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable and punctual cab service in Kalyan."
  }
]

};

const faqData = [
  { question: "Do you provide cab service in Kalyan?", answer: "Yes, Royal Route Cabs offers reliable cab services across Kalyan for local and outstation travel." },
  { question: "Is cab service available 24 hours in Kalyan?", answer: "Yes, our Kalyan cab service operates 24/7." },
  { question: "Do you provide airport cab service from Kalyan?", answer: "Yes, we offer Mumbai airport pickup and drop services from Kalyan." },
  { question: "Which areas in Kalyan do you cover?", answer: "We cover all areas including Kalyan East, Kalyan West, Dombivli, Ulhasnagar, and nearby locations." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a cab for outstation travel?", answer: "Yes, we provide outstation cab services from Kalyan to multiple destinations." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear pricing with no hidden charges." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Kalyan." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for peak hours and long-distance travel." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Abhishek Jadhav",
    feedback: "Royal Route Cabs provided a very dependable cab service in Kalyan. The booking was smooth and the ride was comfortable with timely pickup.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Kulkarni",
    feedback: "Good experience using cab service in Kalyan with Royal Route Cabs. The driver was polite and the journey felt safe and well-managed.",
    rating: 5
  }
];














  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Kalyan & Dombivli",
  "image": "https://www.royalroutecabs.com/assets/images/cab-service-in-kalyan-dombivli.jpg", // replace if needed
  "description": "Book cab service in Kalyan and Dombivli with Royal Route Cabs for safe, reliable, and affordable travel. Available for local, airport, and outstation trips with sedan, SUV, Innova, and luxury cars. 24x7 taxi service with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "499", // starting local fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/cab-service-in-kalyan-dombivli"
  }
};







  return (
    <div>
<Helmet>
  <title>Cab Service in Kalyan & Dombivli | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book cab service in Kalyan & Dombivli with Royal Route Cabs. 24x7 local, airport, and outstation taxi service with affordable fares. Safe, reliable sedan, SUV, Innova & luxury cabs available."
  />

  <meta
    name="keywords"
    content="cab service in kalyan, cab service in dombivali, taxi service in kalyan, taxi service in dombivali, kalyan cab booking, dombivali taxi booking online, local cab service kalyan, local cab service dombivali, outstation cab kalyan, outstation cab dombivali, airport cab service kalyan, airport cab service dombivali, cheap cab service kalyan, cheap cab service dombivali, best taxi service kalyan, best taxi service dombivali, 24x7 cab service kalyan, 24x7 cab service dombivali"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/98.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinkalyan;